import React, { useState, useContext, useCallback } from "react"
import { UserContext } from "../../../context/userContext"
import LoaderFullPage from "../../../components/Loaders"
import gMessages from "../../../styles/GlobalMessages.module.css"
import { TabView, TabPanel } from "primereact/tabview"
import BroadcastTab from "./BroadcastTab"
import InvalidMessagesTab from "./InvalidMessagesTab"
import MySMSChatsTab from "./MySMSChatsTab"
import MyChatMessagesTab from "./MyChatMessagesTab"
import { trApiFindStaffNumber } from "../telerecoveryApi"

export default function GlobalMessages() {
  const [staffPhoneNumber, setStaffPhoneNumber] = useState(null)
  const [loadingStaffNumber, setLoadingStaffNumber] = useState(true)
  const userCtx = useContext(UserContext)
  const { user } = userCtx.session

  const findStaffNumber = useCallback(() => {
    setLoadingStaffNumber(true)

    trApiFindStaffNumber(userCtx.tokenTelerecovery, user.staff_id, user.organization_id, user.organization_alias, user.staff_alias).then(
      (response) => {
        if (response.phoneNumber) {
          setStaffPhoneNumber(response.phoneNumber)
        }
        setLoadingStaffNumber(false)
      },
      (err) => console.log(err)
    )
  }, [user.organization_id, user.staff_id])

  React.useEffect(() => {

    findStaffNumber()
  }, [findStaffNumber])

  if (loadingStaffNumber === true) {
    return <LoaderFullPage></LoaderFullPage>
  }

  return (
    <>
      {loadingStaffNumber === false && staffPhoneNumber &&
        <TabView>
          <TabPanel header="My SMS Chats">
            <MySMSChatsTab staffPhoneNumber={staffPhoneNumber}></MySMSChatsTab>
          </TabPanel>
          <TabPanel header="My Chat Messages">
            <MyChatMessagesTab />
          </TabPanel>
          <TabPanel header="Organization Messages">
            <BroadcastTab></BroadcastTab>
          </TabPanel>
          {user.staff_role <= 4 &&
            <TabPanel header="Invalid Messages">
              <InvalidMessagesTab></InvalidMessagesTab>
            </TabPanel>
          }
        </TabView>
      }
      {loadingStaffNumber === false && !staffPhoneNumber &&
        (<div className={gMessages.noPhone}>
          <h3>You do not have a telerecovery number assigned.</h3>
        </div>)
      }
    </>
  )
}